export function getQueryParamValue(paramName) {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const value= urlParams.get(paramName);
    return value ? decodeURIComponent(value.replace(/\s/g, '+')) : null;
}
  
 